module.exports = __webpack_public_path__ + "static/media/rich.c73e97ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/rich.png
// module id = 308
// module chunks = 0